import selectionReducer from './elements/selection';
import unselectEdgeReducer from './elements/edgeUnselection';
import enableReducer from './elements/enable';
import filtersReducer from './elements/filters';
import filteredElementsReducer from './elements/filteredElements';
import filterMatchingReducer from './elements/filterMatching';
import commercialReducer from './elements/commercial';
import formatsReducer from './elements/formats';
import spotlightReducer from './spotlight';
import teaserReducer from './teasers';
import { modelService } from '../../services/model';

const initialState = {
    selectedElements: [],
    unselectedEdges: [],
    enabledElements: modelService.getAllComponents().map(c => c.id),
    filters: [],
    filteredElements: [],
    filterMatching: [],
    spotlight: false,
    teaserInfo: {
        nextTeaser: undefined,
        alreadyShown: [],
        timeNextTeaserToShow: 0
    },
    showCommercial: true,
    showFormats: false
}

const rootReducer = function combineReducers(state = initialState, action) {
    const newFilters = filtersReducer(state.filters, action);
    const newFilteredElements = filteredElementsReducer(newFilters, state.filteredElements, action);
    const newSelectedElements = selectionReducer(state.selectedElements, newFilteredElements, action);
    const newUnselectedEdges = unselectEdgeReducer(state.unselectedEdges, action);
    const newEnabledElements = enableReducer(state.enabledElements, newSelectedElements, action);
    const newFilterMatching = filterMatchingReducer(newFilters, state.filterMatching, action);
    const newShowCommercial = commercialReducer(state.showCommercial, action);
    const newShowFormats = formatsReducer(state.showFormats, action);
    return {
        selectedElements: newSelectedElements,
        unselectedEdges: newUnselectedEdges,
        enabledElements: newEnabledElements,
        filters: newFilters,
        filteredElements: newFilteredElements,
        filterMatching: newFilterMatching,
        spotlight: spotlightReducer(state.spotlight, action),
        teaserInfo: teaserReducer(newSelectedElements, newFilters, state.teaserInfo, action),
        showCommercial: newShowCommercial,
        showFormats: newShowFormats
    }
}
export default rootReducer;


/*
{
    selectedElements:
        [
            {id:"inspectIT",category:"blub"},
            ...
        ],
    enabledElements: ["inspectIT","Jaeger", ...]
}
*/


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js